import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {BlockSpacer, currentMedia, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import {FlexContainer, FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import moment from 'moment'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {NatResidentParkingUsesLocationState} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import {NatPutParkingUsesRequest} from '../../repository/NatPutParkingUses'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {USER_ATTRIBUTE} from '../../../../../CodeMaster'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import PPRadioGroupForResident from '../../../../../components/shared/forms/resident/PPRadioGroupForResident'
import PPDatePickerForResident from '../../../../../components/shared/forms/resident/PPDatePickerForResident'
import {HKConstants} from '../../../../../HKConstants'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction
    location: Location<NatResidentParkingUsesLocationState>
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType

    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    useArea: Nullable<string>
    useStartDate: Nullable<string>
    userFamilyName: Nullable<string>
    userFirstName: Nullable<string>
    userAttribute: Nullable<string>
    ownerFamilyName: Nullable<string>
    ownerFirstName: Nullable<string>
    carBodyShape: Nullable<string>
    carName: Nullable<string>
    carRegistrationNumber: Nullable<string>
    engineSize: Nullable<string>
    length: Nullable<string>
    height: Nullable<string>
    width: Nullable<string>
    vehicleWeight: Nullable<string>
    vehicleTotalWeight: Nullable<string>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutParkingUsesRequest) => Promise<void>
}

interface State {
    applicantFamilyName: string
    applicantFirstName: string
    useArea: string
    useStartDate: string
    userFamilyName: string
    userFirstName: string
    userAttribute: string
    ownerFamilyName: string
    ownerFirstName: string
    carBodyShape: string
    carName: string
    carRegistrationNumber: string
    engineSize: string
    length: string
    height: string
    width: string
    vehicleWeight: string
    vehicleTotalWeight: string

    currentDate: moment.Moment
    holidays: string[]

    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

export default class NatResidentParkingUsesForm extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            applyButtonDisabled: true,
            applicantFamilyName: '',
            applicantFirstName: '',
            useArea: '',
            useStartDate: '',
            userFamilyName: '',
            userFirstName: '',
            userAttribute: '',
            ownerFamilyName: '',
            ownerFirstName: '',
            carBodyShape: '',
            carName: '',
            carRegistrationNumber: '',
            engineSize: '',
            length: '',
            height: '',
            width: '',
            vehicleWeight: '',
            vehicleTotalWeight: '',
            currentDate: moment(),
            holidays: [],
            isLoadCompleted: false,
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeUseStartDate = this.handleChangeUseStartDate.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
        this.handleUserAttribute = this.handleUserAttribute.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse, holidays] = await Promise.all([
                this.getCurrentDateTime(),
                this.getHoliday(),
            ])

            if (currentTimeResponse && currentTimeResponse.details) {
                this.setState({
                    currentDate: moment(currentTimeResponse.details.currentDateTime),
                })
            }

            const applicantFamilyName = this.props.applicantFamilyName ?? this.state.applicantFamilyName
            const applicantFirstName = this.props.applicantFirstName ?? this.state.applicantFirstName
            const useArea = this.props.useArea ?? this.state.useArea
            const useStartDate = this.props.useStartDate ?? this.state.useStartDate
            const userFamilyName = this.props.userFamilyName ?? this.state.userFamilyName
            const userFirstName = this.props.userFirstName ?? this.state.userFirstName
            const userAttribute = this.props.userAttribute ?? this.state.userAttribute
            const ownerFamilyName = this.props.ownerFamilyName ?? this.state.ownerFamilyName
            const ownerFirstName = this.props.ownerFirstName ?? this.state.ownerFirstName
            const carBodyShape = this.props.carBodyShape ?? this.state.carBodyShape
            const carName = this.props.carName ?? this.state.carName
            const carRegistrationNumber = this.props.carRegistrationNumber ?? this.state.carRegistrationNumber
            const engineSize = this.props.engineSize ?? this.state.engineSize
            const length = this.props.length ?? this.state.length
            const height = this.props.height ?? this.state.height
            const width = this.props.width ?? this.state.width
            const vehicleWeight = this.props.vehicleWeight ?? this.state.vehicleWeight
            const vehicleTotalWeight = this.props.vehicleTotalWeight ?? this.state.vehicleTotalWeight

            this.setState({
                applicantFamilyName: applicantFamilyName,
                applicantFirstName: applicantFirstName,
                useArea: useArea,
                useStartDate: useStartDate,
                userFamilyName: userFamilyName,
                userFirstName: userFirstName,
                userAttribute: userAttribute,
                ownerFamilyName: ownerFamilyName,
                ownerFirstName: ownerFirstName,
                carBodyShape: carBodyShape,
                carName: carName,
                carRegistrationNumber: carRegistrationNumber,
                engineSize: engineSize,
                length: length,
                height: height,
                width: width,
                vehicleWeight: vehicleWeight,
                vehicleTotalWeight: vehicleTotalWeight,
                holidays: holidays === null ? [] : holidays,
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
        }
        this.props.eventEmitter.closeLoading()
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    async getHoliday(): Promise<Nullable<string[]>> {
        const {holidaysRepo, eventEmitter} = this.props

        const minDate: string = HKConstants.CMN.SYC.MIN_HOLIDAY_DATE
        const maxDate: string = HKConstants.CMN.SYC.MAX_HOLIDAY_DATE
        return await this.props.asyncCallFunction(
            holidaysRepo.getHolidays.bind(holidaysRepo, minDate, maxDate),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleUserAttribute(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            userAttribute: event.target.value,
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeUseStartDate(date: string): void {
        this.setState({useStartDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            applicantFamilyName, applicantFirstName, useArea, useStartDate,
            userFamilyName, userFirstName, userAttribute, ownerFamilyName,
            ownerFirstName, carBodyShape, carName, carRegistrationNumber,
            engineSize, length, height, width,
            vehicleWeight, vehicleTotalWeight,
        } = this.state

        let applyButtonDisabled = false

        if (!applicantFamilyName || !applicantFirstName || !useArea ||
            !useStartDate || !userFamilyName || !userFirstName || !userAttribute ||
            !ownerFamilyName || !ownerFirstName || !carBodyShape || !carName ||
            !carRegistrationNumber || !engineSize || !length || !height ||
            !width || !vehicleWeight || !vehicleTotalWeight) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            applicantFamilyName, applicantFirstName, useArea, useStartDate,
            userFamilyName, userFirstName, userAttribute, ownerFamilyName,
            ownerFirstName, carBodyShape, carName, carRegistrationNumber,
            engineSize, length, height, width,
            vehicleWeight, vehicleTotalWeight,
        } = this.state

        let request: Nullable<NatPutParkingUsesRequest>

        request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            useArea: useArea,
            useStartDate: useStartDate,
            userFamilyName: userFamilyName,
            userFirstName: userFirstName,
            userAttribute: userAttribute,
            ownerFamilyName: ownerFamilyName,
            ownerFirstName: ownerFirstName,
            carBodyShape: carBodyShape,
            carName: carName,
            carRegistrationNumber: carRegistrationNumber,
            engineSize: engineSize,
            length: length,
            height: height,
            width: width,
            vehicleWeight: vehicleWeight,
            vehicleTotalWeight: vehicleTotalWeight,
            confirmed: false,
        }

        if (!request) {
            return
        }
        await this.props.onClickApplyConfirmButton(request)
    }

    renderApplicantForm(): ReactElement {
        const {applicantFamilyName, applicantFirstName} = this.state

        const applicantRoom = NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
            convertToRoomNumberForResident(
                NatResidentLoginInfoSessionStorageHelper
                    .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER),
            )

        return (
            <>
                <ItemHeading>
                    申請者
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFamilyName',
                                        maxLength: 10,
                                        value: applicantFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFirstName',
                                        maxLength: 10,
                                        placeholder: '例：太郎',
                                        value: applicantFirstName,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderUseAreaForm(): ReactElement {
        const {useArea} = this.state

        return (
            <>
                <ItemHeading>
                    使用区画
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'駐車場の区画番号'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 20,
                                    name: 'useArea',
                                    value: useArea,
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['useArea']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderUseStartDateForm(): ReactElement {
        const {useStartDate, holidays} = this.state

        return (
            <>
                <ItemHeading>
                    使用開始日
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>駐車場を<BreakPcOnly/>使用開始する日付</span>}
                        required
                        component={
                            <PPDatePickerForResident
                                date={useStartDate}
                                onChange={this.handleChangeUseStartDate}
                                holidays={holidays}
                                itemValue={''}
                                eventKeys={['useStartDate']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderUserForm(): ReactElement {
        const {userFamilyName, userFirstName, userAttribute} = this.state

        return (
            <>
                <ItemHeading>
                    使用者（実際に駐車場を使用される方）
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'使用者氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'userFamilyName',
                                        value: userFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['userFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'userFirstName',
                                        value: userFirstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['userFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'属性'}
                        required
                        component={
                            <GridContainer>
                                <GridItem over={12}>
                                    <PPRadioGroupForResident
                                        data={USER_ATTRIBUTE.values()}
                                        selectValue={userAttribute}
                                        onChange={this.handleUserAttribute}
                                        eventKeys={['userAttribute']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </GridItem>
                            </GridContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderVehicleInfoForm(): ReactElement {
        const {
            ownerFamilyName, ownerFirstName, carBodyShape, carName,
            carRegistrationNumber, engineSize, length, height,
            width, vehicleWeight, vehicleTotalWeight,
        } = this.state

        return (
            <>
                <ItemHeading>
                    車両情報（自動車検査証参照）
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'所有者氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'ownerFamilyName',
                                        value: ownerFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['ownerFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'ownerFirstName',
                                        value: ownerFirstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['ownerFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'車体の形状'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 20,
                                    name: 'carBodyShape',
                                    value: carBodyShape,
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['carBodyShape']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'車名'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 100,
                                    name: 'carName',
                                    value: carName,
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['carName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>自動車登録番号<BreakPcOnly/>または車両番号</span>}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 20,
                                    name: 'carRegistrationNumber',
                                    value: carRegistrationNumber,
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['carRegistrationNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'排気量'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'engineSize',
                                            value: engineSize,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'decimal',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['engineSize']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'L'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'33px'}/>
                    <DimensionTextArea>外寸</DimensionTextArea>
                    <NatResidentApplicationDetailFormItem
                        title={'長さ'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'length',
                                            value: length,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['length']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'cm'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'高さ'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'height',
                                            value: height,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['height']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'cm'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'幅'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'width',
                                            value: width,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['width']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'cm'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'車両重量'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'vehicleWeight',
                                            value: vehicleWeight,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['vehicleWeight']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'kg'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'車両総重量'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 5,
                                            name: 'vehicleTotalWeight',
                                            value: vehicleTotalWeight,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric',
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['vehicleTotalWeight']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'kg'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>)
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                {this.renderApplicantForm()}
                < Box height={'15px'}/>
                {this.renderUseAreaForm()}
                < Box height={'15px'}/>
                {this.renderUseStartDateForm()}
                <Box height={'15px'}/>
                {this.renderUserForm()}
                <Box height={'15px'}/>
                {this.renderVehicleInfoForm()}
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const DimensionTextArea: StyledDiv = styled.div`
  color: ${Colors.AccentDark};
  margin-bottom: 5px;
`

const UnitTextBoxArea: StyledDiv = styled.div`
  ${currentMedia.greaterThan('pc')`
    max-width: 335px;
  `};
`

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`
